import { GET_CDC_CARD_START } from "../../types";

export const card_category = (payload) => ({
  type: GET_CDC_CARD_START,
  payload,
});
